import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink, FiBookOpen, FiRadio, FiVideo, FiNewspaper, FiMic, FiTv, FiGlobe } = FiIcons;

const Resources = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Resources', icon: FiGlobe },
    { id: 'news', name: 'News', icon: FiNewspaper },
    { id: 'podcasts', name: 'Podcasts', icon: FiMic },
    { id: 'youtube', name: 'YouTube', icon: FiVideo },
    { id: 'books', name: 'Books', icon: FiBookOpen },
    { id: 'radio', name: 'Radio', icon: FiRadio },
    { id: 'tv', name: 'TV Shows', icon: FiTv }
  ];

  const resources = [
    // News Sources
    {
      id: 1,
      name: 'The Daily Wire',
      category: 'news',
      description: 'Conservative news and commentary from Ben Shapiro, Matt Walsh, and more.',
      url: 'https://dailywire.com',
      image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=300&h=200&fit=crop',
      rating: 4.8,
      followers: '2.5M',
      verified: true
    },
    {
      id: 2,
      name: 'Breitbart News',
      category: 'news',
      description: 'Breaking news and opinion on politics, world news, and entertainment.',
      url: 'https://breitbart.com',
      image: 'https://images.unsplash.com/photo-1495020689067-958852a7765e?w=300&h=200&fit=crop',
      rating: 4.6,
      followers: '1.8M',
      verified: true
    },
    {
      id: 3,
      name: 'The Epoch Times',
      category: 'news',
      description: 'Independent news and information you can trust.',
      url: 'https://theepochtimes.com',
      image: 'https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=300&h=200&fit=crop',
      rating: 4.7,
      followers: '1.2M',
      verified: true
    },

    // Podcasts
    {
      id: 4,
      name: 'The Ben Shapiro Show',
      category: 'podcasts',
      description: 'Fast-paced analysis of the top cultural and political issues of the day.',
      url: 'https://podcasts.apple.com/us/podcast/the-ben-shapiro-show/id1047335260',
      image: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=300&h=200&fit=crop',
      rating: 4.9,
      followers: '3.2M',
      verified: true
    },
    {
      id: 5,
      name: 'The Dan Bongino Show',
      category: 'podcasts',
      description: 'Hard-hitting political commentary and analysis.',
      url: 'https://bongino.com/podcast',
      image: 'https://images.unsplash.com/photo-1589903308904-1010c2294adc?w=300&h=200&fit=crop',
      rating: 4.8,
      followers: '2.1M',
      verified: true
    },
    {
      id: 6,
      name: 'The Mark Levin Show',
      category: 'podcasts',
      description: 'Constitutional conservative talk from the Great One.',
      url: 'https://marklevinshow.com',
      image: 'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=300&h=200&fit=crop',
      rating: 4.7,
      followers: '1.5M',
      verified: true
    },

    // YouTube Channels
    {
      id: 7,
      name: 'PragerU',
      category: 'youtube',
      description: 'Educational videos promoting conservative values and ideas.',
      url: 'https://youtube.com/prageru',
      image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=300&h=200&fit=crop',
      rating: 4.6,
      followers: '3.1M',
      verified: true
    },
    {
      id: 8,
      name: 'Turning Point USA',
      category: 'youtube',
      description: 'Empowering young Americans to promote freedom and limited government.',
      url: 'https://youtube.com/turningpointusa',
      image: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=300&h=200&fit=crop',
      rating: 4.5,
      followers: '1.8M',
      verified: true
    },
    {
      id: 9,
      name: 'Steven Crowder',
      category: 'youtube',
      description: 'Political commentary with humor and hard-hitting analysis.',
      url: 'https://youtube.com/stevencrowder',
      image: 'https://images.unsplash.com/photo-1551818255-e6e10975bc17?w=300&h=200&fit=crop',
      rating: 4.4,
      followers: '2.3M',
      verified: true
    },

    // Books
    {
      id: 10,
      name: 'The Constitution of the United States',
      category: 'books',
      description: 'The foundational document of American government and liberty.',
      url: 'https://amazon.com/constitution',
      image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=300&h=200&fit=crop',
      rating: 5.0,
      followers: 'Essential',
      verified: true
    },
    {
      id: 11,
      name: 'The Federalist Papers',
      category: 'books',
      description: 'Essential reading for understanding the Constitution and American government.',
      url: 'https://amazon.com/federalist-papers',
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=300&h=200&fit=crop',
      rating: 4.9,
      followers: 'Classic',
      verified: true
    },
    {
      id: 12,
      name: 'Liberty and Tyranny by Mark Levin',
      category: 'books',
      description: 'A conservative manifesto on preserving constitutional government.',
      url: 'https://amazon.com/liberty-tyranny-levin',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop',
      rating: 4.8,
      followers: '500K',
      verified: true
    },

    // Radio Shows
    {
      id: 13,
      name: 'The Rush Limbaugh Show (Archive)',
      category: 'radio',
      description: 'The legendary conservative radio show archives.',
      url: 'https://rushlimbaugh.com',
      image: 'https://images.unsplash.com/photo-1487537708283-b8d3f7faabf6?w=300&h=200&fit=crop',
      rating: 4.9,
      followers: 'Legacy',
      verified: true
    },
    {
      id: 14,
      name: 'The Sean Hannity Show',
      category: 'radio',
      description: 'Conservative talk radio with political analysis and commentary.',
      url: 'https://hannity.com',
      image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=300&h=200&fit=crop',
      rating: 4.7,
      followers: '15M',
      verified: true
    },

    // TV Shows
    {
      id: 15,
      name: 'Tucker Carlson Tonight',
      category: 'tv',
      description: 'Political commentary and analysis on current events.',
      url: 'https://foxnews.com/shows/tucker-carlson-tonight',
      image: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=300&h=200&fit=crop',
      rating: 4.6,
      followers: '3.5M',
      verified: true
    },
    {
      id: 16,
      name: 'The Ingraham Angle',
      category: 'tv',
      description: 'Sharp political commentary from Laura Ingraham.',
      url: 'https://foxnews.com/shows/ingraham-angle',
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=300&h=200&fit=crop',
      rating: 4.5,
      followers: '2.8M',
      verified: true
    }
  ];

  const filteredResources = selectedCategory === 'all' 
    ? resources 
    : resources.filter(resource => resource.category === selectedCategory);

  const ResourceCard = ({ resource }) => (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
    >
      <div className="relative">
        <img
          src={resource.image}
          alt={resource.name}
          className="w-full h-48 object-cover"
        />
        {resource.verified && (
          <div className="absolute top-2 right-2">
            <span className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
              ✓ Verified
            </span>
          </div>
        )}
        <div className="absolute bottom-2 left-2">
          <span className="bg-patriot-red text-white px-2 py-1 rounded-full text-xs font-medium capitalize">
            {resource.category}
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-start justify-between mb-2">
          <h3 className="text-lg font-semibold text-patriot-navy line-clamp-1">
            {resource.name}
          </h3>
          <div className="flex items-center text-yellow-400">
            <span className="text-sm font-medium mr-1">{resource.rating}</span>
            <SafeIcon icon={FiRadio} className="h-4 w-4" />
          </div>
        </div>
        
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {resource.description}
        </p>
        
        <div className="flex items-center justify-between mb-4">
          <span className="text-sm text-gray-500">
            {resource.followers} followers
          </span>
        </div>
        
        <a
          href={resource.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full bg-patriot-red text-white px-4 py-2 rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 font-medium flex items-center justify-center"
        >
          <SafeIcon icon={FiExternalLink} className="h-4 w-4 mr-2" />
          Visit Resource
        </a>
      </div>
    </motion.div>
  );

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-patriot-navy mb-4">Conservative Resources</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover trusted conservative news sources, podcasts, YouTube channels, books, and more 
            from respected voices in the conservative movement.
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 justify-center">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center px-4 py-2 rounded-lg font-medium transition-colors duration-200 ${
                  selectedCategory === category.id
                    ? 'bg-patriot-red text-white'
                    : 'bg-white text-gray-700 hover:bg-gray-100'
                }`}
              >
                <SafeIcon icon={category.icon} className="h-4 w-4 mr-2" />
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Resources Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredResources.map((resource, index) => (
            <motion.div
              key={resource.id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <ResourceCard resource={resource} />
            </motion.div>
          ))}
        </div>

        {/* Submit Resource Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-16 bg-patriot-navy rounded-lg p-8 text-center text-white"
        >
          <h2 className="text-2xl font-bold mb-4">Know a Great Conservative Resource?</h2>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Help us grow our directory of trusted conservative voices. Submit resources that 
            promote constitutional values and conservative principles.
          </p>
          <button className="bg-patriot-red text-white px-6 py-3 rounded-lg hover:bg-patriot-red-dark transition-colors duration-200 font-medium">
            Submit Resource
          </button>
        </motion.div>

        {/* Disclaimer */}
        <div className="mt-8 text-center text-sm text-gray-500">
          <p>
            Resources are independently operated and not affiliated with PatriotHub. 
            We do not endorse all content but recommend these sources for conservative perspectives.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Resources;